//JSUnusedGlobalSymbols
/**
 * ESA Component: On-Demand Event Controller
 * -------------------------------------------------------------
 * @copyright {{PKG_COPYRIGHT}}
 * @license   {{PKG_LICENSE}}
 * @version   {{PKG_VERSION}}, {{PKG_DATE}}
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"
import IntervalHandler from "@phmg/com_hive/src/js/exports/IntervalHandler.js"
import Player from '@vimeo/player';
import {v4 as UUIDv4} from 'uuid';
import StatusHandler from "@phmg/com_hive/src/js/exports/StatusHandler.js";

class OnDemandEventController extends Controller {
  /** Controller ID */
  static CID = "event.ondemand";
  /** Controller name */
  static NAME = "On-Demand Event"

  /** Process ID (UUID) */
  PID;

  Display;
  Player;
  iFrame;

  State;
  // 0 = idle, 1 = playing, -1 = paused
  PlayingState = 0;
  PausedBySystem = 0;

  Records;
  RecordId = 0;
  ContentKey = '';
  ContentType = "vimeo.video"

  // On demand only
  // HTML Boxes
  RecordElements;

  Calling = false;
  Logging = false;
  Checking = false;
  Sleeping = false;
  READY = { Player : false, Record : false, State : false };

  LogQueue = [];
  LogDate = 0;
  LogData;

  Options = {
    logEnabled      : true,
    logInterval     : 30,
    logQueueTimeout : .5,
    noLogTimeout    : 90,
  }


  // Handlers
  CallHandler;
  SH;
  IH;
  loadingDisplay;

  // Selectors
  DISPLAY_SELECTOR = "#ondemandDisplay";

  /**
   * Fires on "DOMContentLoaded" event
   */
  initiate() {
    super.initiate();

    // Check if display container is present.
    // If not it means there's no video / stream to track, and we can bail
    this.Display = document.querySelector(this.DISPLAY_SELECTOR);
    if (!this.Display) {
      this.utils.odb("No display.", this);
      return;
    }

    this.loadingDisplay = Hive.getLoadingDisplay();

    // Validate our context / build the request
    let validData = this.validateContext();
    if (!validData) return;

    // Add loading display
    this.onLoad();

    // Set process UUID
    this.PID = UUIDv4();
    validData['pid'] = this.PID;

    // Initiate StatusHandler
    this.SH = new StatusHandler(this);

    // Initiate the Call Handler
    let url = '/index.php?option=com_esa&format=json';
    //const CallHandlerClass = window.Hive.getCallHandler();
    this.CallHandler = window.Hive.getCallHandler(this, { silent : true, url : url });

    // Make the initial request
    this.CallHandler.postRequest('api.post',
      this.CallHandler.toFormData({
        request : "online.initiate",
        context : "com_esa.event.ondemand",
        jform   : validData
      }),
      (success, responseData, message) => {
        if (success) {
          let html = responseData['html'] || { media : '', records : '' };
          let records = responseData['records'] || null;
          if (html.media && html.records && records) {

            // Set the records
            this.Records = records;

            // Insert the embed code
            this.utils.replaceElement(`[data-content="media"]`, html.media, (mediaHtml) => {

              // Create player
              this.initiatePlayer();

              // Start the Interval
              //const self = this;
              this.IH = new IntervalHandler(this.onIntervall.bind(this), { pulse : this.Options.logInterval, onInit : 'tik' });

              // Add global event listeners
              window.addEventListener("beforeunload", () => {
                this.onBeforeUnload();
              });

              // Add visibility listeners
              document.addEventListener("visibilitychange", () => {
                if (document.visibilityState === 'hidden') {
                  this.onDocumentHide();
                } else {
                  this.onDocumentShow();
                }
              });

              // Add click listener
              document.addEventListener("click", () => {
                this.onDocumentClick();
              });

              // Fire the DOM update event
              mediaHtml.dispatchEvent(new CustomEvent("joomla:updated", { bubbles : true, cancelable : true }));

              // Insert records
              // On demand only
              this.utils.replaceElement(`[data-content="records"]`, html.records, (recordsHtml) => {
                recordsHtml.dispatchEvent(new CustomEvent('joomla:updated', { bubbles : true, cancelable : true }));

                // Set the interface
                this.RecordElements = [].slice.call(this.Display.querySelectorAll('[data-content_key]'));
                this.addRecordInterface();
              });

              // Set active
              this.setActive();
            });
          } else {
            // Handle unsuccessful response
            this.setError({ message : message || 'GLOBAL_ERROR_RESPONSE_INVALID' });
          }
        } else {
          // Handle error
          this.setError({ message : message || 'GLOBAL_ERROR_UNDEFINED' });
        }
      }, true)
  }


  /**
   * CONTEXT
   */

  /**
   * validateContext
   * @return {null|{event_id:number, registration_id:number, content_item_id:number, content_id:number,content_type:string }}
   */
  validateContext() {
    let eventId = this.context['eventId'] || 0;
    let registrationId = this.context['registrationId'] || 0;
    let contentItemId = this.context['contentItemId'] || 0;
    let contentId = this.context['contentId'] || 0;
    let contentType = this.context['contentType'] || '';
    let accessLevel = this.context['accessLevel'] || 0;

    // Check mandatory fields
    if (!eventId || !contentItemId || !contentId || !contentType) {
      this.setError({ message : 'GLOBAL_ERROR_NO_INPUT' });

      return null;
    }

    // Simple access check
    if (accessLevel < 1 || (!registrationId && accessLevel < 5)) {
      this.setError({ message : 'GLOBAL_ERROR_UNAUTHORIZED' });

      return null;
    }

    return { event_id : eventId, registration_id : registrationId, content_item_id : contentItemId, content_id : contentId, content_type : contentType, };
  }

  /**
   * Check the current loaded content
   */
  checkContent() {
    this.utils.odb('Checking content.', this);

    // If the player is not ready, we can't access it
    // But maybe the event just didn't fire
    // if (!this.READY.Player) return;

    // Already checking
    if (this.Checking) return;
    this.Checking = true;

    // Get the video id
    this.Player.getVideoId()
      .then((videoId) => {
        this.Checking = false;

        // Initiate the (new) record
        this.initiateRecord(videoId);
      })
      .catch((error) => {
        this.Checking = false;

        this.setWarning(error)
      });
  }


  /**
   * GENERAL EVENTS
   */

  /**
   * Load callback
   */
  onLoad() {
    this.loadingDisplay.add(this.Display, true).display();
  }

  /**
   * Ready callback
   */
  onReady() {
    this.loadingDisplay.add(this.Display, true).success();
  }

  /**
   * Error event
   */
  onError() {
    // Add body class
    document.body.classList.add('has-error');

    // Log if Error data is set
    const log = this.errorData ? Object.assign({}, this.State, { event : 'error', info : this.errorData }) :
      Object.assign({}, this.State, { event : 'error', info : '' });
    this.addLog(log);

    // Remove iframe
    if (this.Display) this.loadingDisplay.add(this.Display, true).error();
    if (this.iFrame) this.iFrame.remove();

    // Set controller status
    this.error();
  }

  /**
   * Sleeping Event
   */
  onSleep() {
    this.Sleeping = true;

    const log = Object.assign({}, this.State, { event : 'sleep' });
    this.addLog(log);

    // Pause playback
    if (this.PlayingState === 1) {
      this.playerPause();
    } else {
      this.PlayingState = 0;
    }
  }

  /**
   * WakeUp Event
   */
  onWakeup() {
    this.Sleeping = false;

    let log = Object.assign({}, this.State, { event : "wakeup" });
    this.addLog(log);

    // Resume if paused
    if (this.PlayingState === -1) {
      this.playerPlay();
    } else {
      this.triggerPlaybackEvent();
    }
  }


  /**
   * DOCUMENT/WINDOW EVENTS
   */

  /**
   * Sends 'unload' event, breaks chaining
   */
  onBeforeUnload() {
    if (!this.Logging) return

    this.triggerPlaybackEvent();

    const log = this.#buildLog(Object.assign({}, this.State, { event : "unload" }));
    this.CallHandler.sendRequest("api.post",
      this.CallHandler.toFormData({
        request : "online.close",
        context : "com_esa.event.ondemand",
        log     : log
      }), 'POST');

    //this.Logging = false;
  }

  /**
   * Send a last request before document gets closed
   */
  onDocumentHide() {
    if (!this.Logging) return;

    let log = Object.assign({}, this.State, { event : 'hide' });
    this.addLog(log);

    if (this.PlayingState !== 0) this.triggerPlaybackEvent();
  }

  /**
   * Resume playing when paused
   */
  onDocumentShow() {
    if (!this.Logging) return;

    let log = Object.assign({}, this.State, { event : 'show' });
    this.addLog(log);

    if (this.PlayingState !== 0) this.triggerPlaybackEvent();
  }

  /**
   * Check if user is still there
   */
  onDocumentClick() {
    if (!this.Logging) return;

    // Wakeup if set to sleep
    if (this.Sleeping) {
      this.setWakeup();

      return;
    }

    // Break the series
    // @todo think about a way to break series without conflict with an actual event
    if (this.PlayingState !== 0) {
      //let log = Object.assign({}, this.State, { event : 'click' });
      //this.addLog(log);
      //
      //let event = this.getState('event', null);
      //if (this.PlayingState === 1 || event === null || event === 'paused' || event === 'playing') {
      //	this.triggerPlaybackEvent();
      //}
    }

  }


  /**
   * EVENT TRIGGERS
   */

  /**
   * Set active
   */
  setActive() {
    // Set controller status
    this.active();
  }

  /**
   * Set warning
   * @param [input]
   */
  setWarning(input) {
    // Add body class
    document.body.classList.add('has-warning');

    // Bail if error isn't set
    if (!input) return;

    // Set message
    let message = 'GLOBAL_WARNING';
    if (typeof input === 'string') {
      message = input;
      input = {};
    } else if (input.message) {
      message = input.message;
    }

    // Display the warning
    this.utils.warning(message, input);
  }

  /**
   * Set error
   * @param input
   */
  setError(input) {

    // Set message
    let message = 'GLOBAL_ERROR_UNDEFINED';
    if (typeof input === 'string') {
      message = input;
      input = {};
    } else if (input.message) {
      message = input.message;
    }

    // Display the error
    this.utils.error(message, input, false);

    // Set the controller error
    this.errorData = message;

    // Trigger the event
    this.onError();
  }

  /**
   * Display a warning message, try to pause the video
   * @param {string|{}} [input]
   */
  setSleeping(input) {
    // Display the info
    let message = 'Klicken Sie bitte auf diese Meldung.';
    if (typeof input === 'string') {
      message = input;
    } else if (input.message) {
      message = input.message;
    }
    this.utils.info(message);

    // Log the sleeping event
    this.onSleep();
  }

  //noinspection JSUnusedLocalSymbols
  /**
   * Display a warning message, try to pause the video
   * @param {string|{}} [input]
   */
  setWakeup(input) {
    // Log the sleeping event
    this.onWakeup();
  }


  /**
   * HANDLER EVENTS
   */

  /**
   * Handle the interval
   */
  onIntervall() {
    this.IH.tik();

    if (!this.READY.Player || !this.READY.Record) {
      this.checkContent();
    }

    // Trigger an update of the state
    if (this.READY.State && this.PlayingState !== 0) {
      this.triggerPlaybackEvent();
    }

    // Test connection if not logging
    if (!this.LogDate || ((new Date()).getTime() - this.LogDate) > this.Options.noLogTimeout * 1000) {
      this.testConnection();
    }
  }


  /**
   * PLAYER
   */

  /**
   * Create a new player instance
   */
  initiatePlayer() {

    // Destroy current player if it exists
    if (typeof this.Player === 'object') {
      this.Player.destroy()
        .then(() => {
          this.utils.odb('Previous player instance destroyed', this)
          this.initiatePlayer();
        })
        .catch((error) => {
          this.setError(error);
        });
      return;
    }

    // Create a new instance and bind the events
    try {
      // Get the iframe
      this.iFrame = this.Display.querySelector('iframe');
      this.Player = new Player(this.iFrame);

      // Use this ready promise if loaded event doesn't fire
      this.Player.ready()
        .then(() => {
          this.utils.odb('Player ready.', this);
          this.READY.Player = true;
        });

      this.utils.odb('Player created.', this);

      // Valid events are: adstarted, adcompleted, aderror, adskipped, adallcompleted, adclicked,
      // bufferend, bufferstart,
      // chapterchange, chromecastconnected, controlbarvisibilitychanged, cuechange, cuepoint,
      // durationchange, ended, error, fullscreenchange,
      // emailcapturefailed, emailcapture,
      // interactivehotspotclicked, interactiveoverlaypanelclicked,
      // liveeventended, liveeventstarted, livestreamoffline, livestreamonline,
      // loadeddata, loadstart, loadedmetadata, loaded,
      // motionend, motionstart, camerachange, webvrhardwareavailable, enterwebvr, exitwebvr,
      // enterpictureinpicture, leavepictureinpicture,
      // spatialunsupported,
      // pause, play, playing, playbackratechange, ratechange, progress, qualitychange,
      // ready, resize, seeking, seeked,
      // spacechange, texttrackchange, timeupdate, volumechange, waiting.

      // When loading a new video
      this.Player.on('loaded', (data) => {
        this.utils.odb('Player ready (loaded event).', this);
        this.READY.Player = true;

        let videoId = data.id || 0;
        this.initiateRecord(videoId);
      });

      // Playback events
      // These events have data with duration, percent and seconds
      this.Player.on('pause', (data) => {
        this.onPlaybackEvent(data, 'paused');
        this.PlayingState = -1;
      });
      this.Player.on('play', (data) => {
        this.onPlaybackEvent(data, 'playing');
        this.PlayingState = 1;
        this.PausedBySystem = 0;
      });
      this.Player.on('playing', (data) => {
        this.onPlaybackEvent(data, 'playing');
        this.PlayingState = 1;
        this.PausedBySystem = 0;
      });
      this.Player.on('ended', (data) => {
        this.onPlaybackEvent(data, 'ended');
        this.PlayingState = 0;
      });

      // When seeking starts
      this.Player.on('seeking', (data) => {
        // let event = this.getState('event', '');
        // if (this.PlayingState === 1) this.onPlaybackEvent(data, 'playing');
        this.onPlaybackEvent(data, 'seeked');
        this.PlayingState = 0;
      });

      // When seeking ends
      this.Player.on('seeked', (data) => {
        this.onPlaybackEvent(data, 'seeked');
        this.triggerPlaybackEvent();
      });

      // State update events
      // These events update state data but don't trigger a log

      // fullscreen: bool
      this.Player.on('fullscreenchange', (data) => {
        this.setState(data);
        this.utils.odb(data, this);
      });
      // volume: float
      this.Player.on('volumechange', (data) => {
        this.setState(data);
        this.utils.odb(data, this);
      });
      // quality: string
      this.Player.on('qualitychange', (data) => {
        this.setState(data);
        this.utils.odb(data, this);
      });

      // Non

      // buffering: void
      //this.Player.on('bufferstart', () => {
      //	let log = Object.assign({}, this.State, { event : 'bufferstart' });
      //	this.addLog(log);
      //});
      // buffering: void
      //this.Player.on('bufferend', () => {
      //	let log = Object.assign({}, this.State, { event : 'bufferend' });
      //	this.addLog(log);
      //});
      /*this.Player.on('waiting', () => {
        let log = Object.assign({}, this.State, { event : 'waiting' });
        this.addLog(log);
      });*/

      if (this.utils.idb()) {

        this.Player.on('interactiveoverlaypanelclicked', (data) => {
          data.event = 'interactiveoverlaypanelclicked';
          console.log('interactiveoverlaypanelclicked');
          console.log(data);
        });

        this.Player.on('interactivehotspotclicked', (data) => {
          data.event = 'interactivehotspotclicked';
          console.log('interactivehotspotclicked');
          console.log(data);
        });

        this.Player.on('enterpictureinpicture', (data) => {
          data.event = 'enterpictureinpicture';
          console.log('enterpictureinpicture');
          console.log(data);
        });

        this.Player.on('leavepictureinpicture', (data) => {
          data.event = 'leavepictureinpicture';
          console.log('leavepictureinpicture');
          console.log(data);
        });
      }

      // This event fires when the playback position of the video changes,
      // generally every 250 ms during playback, but the interval can vary depending on the browser.
      // Maybe use it to check if video is still playing
      /*self.Player.on( 'timeupdate', ( data ) =>
      {

      } );*/
      /*this.Player.on('error', (data) => {
        console.log('General error.');
        console.log(data);
      });*/

      //this.Player.on('loadeddata', () => console.log('loadeddata'));
      //this.Player.on('loadedmetadata', () => console.log('loadedmetadata'));
      //this.Player.on('loadstart', () => console.log('loadstart'));
      //this.Player.on('bufferstart', () => console.log('bufferstart'));
      //this.Player.on('bufferend', () => console.log('bufferend'));
      //this.Player.on('durationchange', () => console.log('durationchange'));
      //this.Player.on('waiting', () => console.log('waiting'));

    } catch (error) {
      this.setError(error);
    }
  }

  /**
   * Start playback
   * NOTE: On certain mobile devices, including those running iOS,
   * and in certain desktop browsers like Chrome and Safari, you can't
   * programmatically trigger the initial playback of a video.
   * This method becomes available once the viewer has started playback by
   * manually tapping the video's play button. For more information on
   * working with autoplay in various browsers, see our Help Center.
   * @param {null|function} callback
   * On demand only
   */
  playerPlay(callback = null) {
    callback = callback || function() {};

    let playPromise = this.Player.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {
        // Automatic playback started!
        callback(true, {});
      })
        .catch((error) => {
          // Autoplay was prevented
          callback(false, error);
        });
    }
  }

  /**
   * Pause playback
   * @param {null|function} callback
   * On demand only
   */
  playerPause(callback = null) {
    callback = callback || function() {};

    this.Player.pause()
      .then(() => {
        this.PausedBySystem = 1;
        callback(true, {});
      })
      .catch((error) => {
        callback(false, error);
      });
  }

  /**
   * Load a video
   * @param {number|string} videoId
   * @param {null|function} callback
   * On demand only
   */
  playerLoad(videoId, callback = null) {
    callback = callback || function() {};

    this.Player.loadVideo(videoId)
      .then((id) => {
        callback(true, { videoId : id });
      })
      .catch((error) => {
        callback(false, error);

        this.setError(error);
      });
  }

  /**
   * Jump to a position
   * @param {Number} position
   * @param {null|function} callback
   * On demand only
   */
  playerSeek(position, callback = null) {
    callback = callback || function() {};

    this.Player.setCurrentTime(position)
      .then((seconds) => {
        callback(true, { position : seconds });
      })
      .catch((error) => {
        callback(false, error);

        this.setWarning(error);
      });
  }

  /**
   * Update playback state (fires on pause, play, seek, ended...)
   * @param {{}} data
   * @param {String} event
   */
  onPlaybackEvent(data, event) {
    if (!data || !event) return;

    // Bail if we don't have a duration
    let duration = data.duration || 0;
    if (!duration) return;

    let position = data.seconds || data.position || 0;
    let triggered = data.triggered || 0;

    // Build update data
    let progress = this.utils.percentage(position, duration);
    let update = { position : position, duration : duration, progress : progress, triggered : triggered, event : event };

    this.setState(update);

    // Set playing state icon
    let state = 'idle';
    if (this.PlayingState > 0) {
      state = 'playing';
    } else if (this.PlayingState < 0) {
      state = 'paused';
    }
    this.SH.setStatus('state', state);
  }

  /**
   * Trigger an update
   * @param {String} [event]
   */
  triggerPlaybackEvent(event) {
    // Get playback position, duration and paused state
    Promise.all([
      this.Player.getCurrentTime(),
      this.Player.getDuration(),
      this.Player.getPaused()
    ])
      .then((values) => {
        if (!event || !event.length) {
          let paused = values[2];
          if (paused) {
            event = 'paused';
            this.PlayingState = -1;
          } else {
            event = 'playing';
            this.PlayingState = 1;
          }
        }

        this.onPlaybackEvent({ seconds : values[0], duration : values[1], triggered : 1 }, event);
      })
      .catch((error) => this.setWarning(error));
  }


  /**
   * RECORDS
   */

  /**
   * Initiate record / ing
   * @param {Number} contentId
   */
  initiateRecord(contentId) {
    // If we made it this far, player must be ready
    if (!this.READY.Player) {
      this.utils.odb(`Player is ready.`, this);
      this.READY.Player = true;
    }

    // Check if content is already active
    let contentKey = `${this.ContentType}.${contentId}`;
    if (this.ContentKey === contentKey) {
      this.utils.odb(`Record (${contentKey}) already initiated.`, this);
      this.READY.Record = true;
      return;
    }

    // Initiate content
    this.utils.odb(`Initiate record (${contentKey}).`, this);

    // Reset the state and ready markers
    this.State = {};
    this.READY.Record = false;
    this.READY.State = false;
    this.PlayingState = 0;

    // Get the record
    const CurrentRecord = this.getRecord(contentKey);
    if (!CurrentRecord) {
      this.setError({ message : 'Fehler bei der Initialisierung, bitte laden Sie die Seite neu.' })
      return;
    }

    // Check if the record has an id
    let recordId = CurrentRecord.id || 0;
    if (!recordId) {
      this.RecordId = 0;
      this.Logging = false;
      this.utils.odb(`Record (${contentKey}) has no ID, assuming simulation and continue.`, this);
    } else {
      this.RecordId = recordId;
      this.Logging = true;
      this.utils.odb(`Record (${contentKey}) has the ID ${recordId}.`, this);
    }

    // Set the contentKey, remove checking marker and set content to ready
    this.ContentKey = contentKey;

    // Record is ready
    this.utils.odb(`Record (${contentKey}) is ready.`, this);
    this.READY.Record = true;

    // Initiate the state
    this.initiateState(contentId);

    // Set the record display active
    // On demand only
    this.updateRecordInterface();

    // Remove loading display
    this.onReady();
  }

  /**
   * Get the records
   * @return {{}}
   */
  getRecords() {
    if (!this.Records) {
      this.utils.odb('Loading records from context.', this);
      const { records : Records } = this.context;
      this.Records = Records || null;
    }
    return this.Records;
  }

  /**
   * Get a record
   * @param {string} key
   * @return {{}|null}
   */
  getRecord(key) {
    const Records = this.getRecords();
    return Records[key] || null;
  }

  /**
   * Make the records clickable
   * On demand only
   */
  addRecordInterface() {
    if (!this.RecordElements) return;

    if (this.utils.idb()) {
      this.RecordElements.forEach(element => {
        let key = element.dataset['content_key'] || null;
        let data = key ? this.getRecord(key) : null;
        if (data && data['item_embed_url'] !== undefined) {
          element.addEventListener('click', () => {
            let url = this.getRecord(element.dataset['content_key'])['item_embed_url'];
            this.playerLoad(`${url}&context=embed_playlist.`);
          })
        }
      })
    }
  }

  /**
   * Mark record when it's active
   * On demand only
   */
  updateRecordInterface() {
    if (!this.RecordElements || !this.ContentKey) return;

    //noinspection EqualityComparisonWithCoercionJS
    this.RecordElements.forEach(element => element.classList.toggle('active', (element.dataset['content_key'] == this.ContentKey)));
  }

  /**
   * Update html
   * @param {object} recordData
   * @param {string} [recordHtml]
   */
  updateDisplay(recordData, recordHtml) {
    if (!this.Logging) return;

    // Update the local record data
    let contentKey = recordData['item_content_key'] || '';
    const Records = this.getRecords();
    Records[contentKey] = Object.assign({}, Records[contentKey], recordData);

    // Update the display
    let recordId = recordData.id;
    const displayElement = document.querySelector(`[data-record_id="${recordId}"] > [data-content="record.item"]`);
    if (!displayElement) return;

    // Use HTML or call
    let itemOrderingValue = displayElement.dataset['item_ordering'] || '1';
    let itemOrderingDisplay;
    if (recordHtml) {
      this.utils.replaceElement(displayElement, recordHtml, (element) => {
        // Workaround, update the ordering number
        if (this.utils.idb() && itemOrderingValue && (itemOrderingDisplay = element.querySelector('[data-content="record.item.ordering"]')) !== null) {
          itemOrderingDisplay.textContent = itemOrderingValue;
        }
        element.dispatchEvent(new CustomEvent('joomla:updated', { bubbles : true, cancelable : true }));
      }, false);
    } else {
      this.CallHandler.getRequest('api.get',
        {
          request       : 'online.record.display',
          context       : 'com_esa.event.ondemand',
          record_id     : recordId,
          item_ordering : itemOrderingValue,
          pid           : this.PID
        },
        (success, responseData) => {
          if (success && typeof responseData.html === 'string') {
            this.utils.replaceElement(displayElement, responseData.html, (element) => {
              if (this.utils.idb() && itemOrderingValue && (itemOrderingDisplay = element.querySelector('[data-content="record.item.ordering"]')) !== null) {
                itemOrderingDisplay.textContent = itemOrderingValue;
              }
              element.dispatchEvent(new CustomEvent('joomla:updated', { bubbles : true, cancelable : true }));
            }, false);
          }
        },
        true)
    }
  }


  /**
   * STATE
   */

  /**
   * Reset and rebuild the state for the current video
   * @param {Number} contentId
   */
  initiateState(contentId) {
    this.utils.odb("Initiate state.", this);

    // Set the new ID
    this.setState({ videoId : contentId });

    // Get playback position, duration and fire initiated event
    Promise.all([this.Player.getCurrentTime(), this.Player.getDuration()])
      .then((values) => {

        // Trigger the initiated event
        this.onPlaybackEvent({ position : values[0], duration : values[1] }, 'initiated');

        // And playback state event right afterward
        this.triggerPlaybackEvent();

        // Set state to ready
        this.utils.odb('State is ready.', this);
        this.READY.State = true;
      })
      .catch((error) => this.setError(error));
  }

  /**
   * Set and log the current state
   * @param {{}} data
   */
  setState(data = {}) {
    // Check player & record
    if (!this.READY.Player || !this.READY.Record) {
      this.utils.odb('Record not initiated.', this);
      this.checkContent();
    }

    // No state updates when on hold - why not?
    // if (this.Checking) return;

    // Update the state
    Object.assign(this.State, data);
    this.utils.odb(this.State, this);

    // Create a log entry if data contains an event
    let event = data.event ? data.event : null;
    if (event) this.addLog(this.State);
  }

  /**
   * Get a variable from state
   * @param {string} name
   * @param {null|*} def
   * @return {null|*}
   */
  getState(name, def = null) {
    const state = this.State;
    if (typeof state[name] !== 'undefined' && state[name] !== null) {
      return state[name];
    }

    return def;
  }

  /**
   * Set state value if not defined
   * @param {string} name
   * @param value
   */
  defState(name, value) {
    if (this.getState(name)) return;

    let defData = {};
    defData[name] = value;
    this.setState(defData);
  }


  /**
   * LOGGING
   */

  /**
   * Log a state set
   * @param data
   */
  addLog(data = {}) {
    if (!this.Logging) return;

    // Validate / filter the data
    if (!this.#validateLog(data)) return;

    // Build the log data
    let log = this.#buildLog(data);

    // If sleeping, only errors, wakeup and sleep events will get through
    if (this.Sleeping) {
      this.utils.odb(`Sleeping, not logging event ${log.event}.`, this);
      if (log.event !== 'error' && log.event !== 'wakeup' && log.event !== 'sleep') return;
    }

    // Add data to call stack
    this.LogQueue.push(log);

    // Start calling
    this.#saveLog();
  }

  /**
   * Build the log data
   * @param {{}} data
   * @return {{}}
   */
  #buildLog(data) {
    const logData = {};
    logData.record_id = this.RecordId;
    logData.pid = this.PID;
    logData.event = data.event;
    logData.info = data.info || '';
    logData.created = this.utils.getISODate();
    logData.data = Object.assign({}, data);

    return logData;
  }

  /**
   * Check if a state is worth saving
   * @param {{}} data
   * @return {boolean}
   */
  #validateLog(data = {}) {
    // Record ID must be set.
    if (!this.Logging || !this.RecordId) return false;

    // An error may pass without videoId or duration
    return !(!data.videoId && data.event !== 'error');
  }

  /**
   * Save log data
   */
  #saveLog() {
    // Return if nothing is to be saved
    if (!this.LogQueue.length) {
      this.Calling = false;

      return;
    }

    // Return if already calling
    if (this.Calling) return;
    this.Calling = true;

    // Get the next log data
    const log = this.LogQueue.shift();
    this.CallHandler.postRequest('api.post',
      this.CallHandler.toFormData({
        request : "online.log",
        context : "com_esa.event.ondemand",
        log     : log
      }),
      (success, responseData, message) => {
        this.Calling = false;

        // Set date and data from response
        this.LogDate = (new Date()).getTime();
        this.LogData = { success : success, response : responseData, message : message };

        // Set connection and log status
        this.SH.setStatus('log', (success ? 'success' : 'fail'));
        this.SH.setStatus('connection', (success ? 'connected' : 'disconnected'));

        // Schedule next call
        let timeOut = success ? this.Options.logQueueTimeout * 1000 : (this.Options.logQueueTimeout * 3) * 1000;
        this.utils.addTimer(() => {
          this.#saveLog()
        }, timeOut, 'save_log');

        // Check the response for additional commands
        this.onResponse(success, responseData);
      },
      true)
  }


  /**
   * RESPONSE INTERFACE
   */

  /**
   * Check response for commands
   *
   * @param {boolean} success
   * @param {object|null} responseData
   */
  onResponse(success, responseData) {
    responseData = responseData || null;

    if (!responseData) {
      // this.setError({ message : 'Verbindung zum Server verloren, bitte laden Sie die Seite neu.' });
      return;
    }

    // Check for commands in the request
    let commands = responseData.hasOwnProperty('cmd') && typeof responseData.cmd === 'object' ? responseData.cmd : null;
    if (!commands || typeof commands !== 'object') return;

    // Options update
    if (commands.hasOwnProperty('doOptions') && commands.doOptions !== undefined) {
      Object.assign(this.Options, commands.doOptions)
      this.IH && this.IH.adjust(this.Options.logInterval);
    }

    // Log
    if (commands.hasOwnProperty('doLog')) {
      let data = commands.doLog.data || {};
      let log = Object.assign({}, this.State, data)
      this.addLog(log);
    }

    // Set sleeping
    if (commands.hasOwnProperty('doSetSleep')) {
      this.setSleeping(commands.doSetSleep);
    }

    // Trigger an error
    if (commands.hasOwnProperty('doSetError') && commands.doSetError !== undefined) {
      this.setError(commands.doSetError);
    }

    // Show message
    if (commands.hasOwnProperty('doMessage') && commands.doMessage !== undefined) {
      let message = commands.doMessage.message;
      let type = commands.doMessage.type || 'info';
      this.utils.displayMessage(message, type);
    }

    // Update the display
    if (commands.hasOwnProperty('doUpdateDisplay') && commands.doUpdateDisplay !== undefined) {
      if (Array.isArray(commands.doUpdateDisplay)) {
        this.updateDisplay(...commands.doUpdateDisplay);
      } else {
        this.updateDisplay(commands.doUpdateDisplay);
      }
    }

    // Update context
    if (commands.hasOwnProperty('doReloadContext') && commands.doReloadContext !== undefined) {
      Object.assign(this.context, commands.doReloadContext);
      let contentId = this.context.contentId;
      this.ContentKey = '';
      this.initiateRecord(contentId);
    }

    // Update context
    if (commands.hasOwnProperty('doUpdateContext') && commands.doUpdateContext !== undefined) {
      Object.assign(this.context, commands.doUpdateContext);
    }

    // Force a state
    if (commands.hasOwnProperty('doSetState') && commands.doSetState !== undefined) {
      this.setState(commands.doSetState);
    }
  }


  /**
   * DEBUGGING
   */

  /**
   * Test the connection to the server
   */
  testConnection() {
    this.CallHandler.getRequest('api.get',
      { request : 'connected' },
      (success) => {
        this.SH.setStatus('connection', (success ? 'connected' : 'disconnected'));
      },
      true)
  }
}

export default OnDemandEventController
